import { BranchCompanyType, MerchantType, OrdinaryPersonPrefixType, PrefixNameType, TypeOfPerson } from "@/enums/enums";
import { i18n } from "@/i18n";
import { MerchantInFoModel } from "@/model/merchant/MerchantInFoModel";
import {
  MerchantPackageRightApplicationModel,
  MerchantPackageRightModel,
  MerchantPackageRightPeakAccountApplicationAccountingPolicySettingModel,
  MerchantPackageRightPeakAccountApplicationAccountsModel,
  MerchantPackageRightPeakAccountApplicationDocumentSettingModel,
  MerchantPackageRightPeakAccountApplicationExpenseModel,
  MerchantPackageRightPeakAccountApplicationFinanceModel,
  MerchantPackageRightPeakAccountApplicationModel,
  MerchantPackageRightPeakAccountApplicationRevenueModel,
  MerchantPackageRightPeakAccountApplicationSettingModel,
  MerchantPackageRightPeakAccountApplicationUserSettingModel,
  MerchantPackageRightPeakAssetApplicationModel,
  MerchantPackageRightPeakTaxApplicationModel,
  SelectedMerchantModel,
  UserRoleInfoModel,
} from "@/model/merchant/selectedMerchantModel";
import { GetTypeOfPersonBySearchedAddress } from "./shareHelper";

function GetMerchantPackageRightApplication(applicationRaw: any): MerchantPackageRightApplicationModel {
  return {
    peakAccount: applicationRaw.peakAccount,
    oldPeakAccount: applicationRaw.oldPeakAccount,
    peakPayroll: applicationRaw.peakPayroll,
    peakAsset: applicationRaw.peakAsset,
    peakBoard: applicationRaw.peakBoard,
    peakTax: applicationRaw.peakTax,
    peakLineConnect: applicationRaw.peakLineConnect,
    peakMobile: applicationRaw.peakMobile,
    peakDocument: applicationRaw.peakDocument,
  };
}
function GetMerchantPackageRightPeakAccountApplicationRevenue(
  revenueRaw: any
): MerchantPackageRightPeakAccountApplicationRevenueModel {
  return {
    quotation: revenueRaw.quotation,
    invoice: revenueRaw.invoice,
    invoiceAsset: revenueRaw.invoiceAsset,
    receipt: revenueRaw.receipt,
    receiptAsset: revenueRaw.receiptAsset,
    taxInvoice: revenueRaw.taxInvoice,
    creditNote: revenueRaw.creditNote,
    billingNote: revenueRaw.billingNote,
    debitNote: revenueRaw.debitNote,
    recurringInvoice: revenueRaw.recurringInvoice,
    recurringReceipt: revenueRaw.recurringReceipt,
  };
}
function GetMerchantPackageRightPeakAccountApplicationExpense(
  expenseRaw: any
): MerchantPackageRightPeakAccountApplicationExpenseModel {
  return {
    purchaseOrder: expenseRaw.purchaseOrder,
    purchaseOrderAsset: expenseRaw.purchaseOrderAsset,
    expense: expenseRaw.expense,
    purchaseAsset: expenseRaw.purchaseAsset,
    purchaseTaxInvoice: expenseRaw.purchaseTaxInvoice,
    receivedCreditNote: expenseRaw.receivedCreditNote,
    receivedDebitNote: expenseRaw.receivedDebitNote,
    combinePaymentNote: expenseRaw.combinePaymentNote,
    recurringExpense: expenseRaw.recurringExpense,
  };
}
function GetMerchantPackageRightPeakAccountApplicationFinance(
  financeRaw: any
): MerchantPackageRightPeakAccountApplicationFinanceModel {
  return {
    addFinance: financeRaw.addFinance,
    reconcile: financeRaw.reconcile,
    statement: financeRaw.statement,
  };
}
function GetMerchantPackageRightPeakAccountApplicationAccounts(
  accountRaw: any
): MerchantPackageRightPeakAccountApplicationAccountsModel {
  return {
    addAccount: accountRaw.addAccount,
    actionJournal: accountRaw.actionJournal,
  };
}
function GetMerchantPackageRightPeakAccountApplicationDocumentSetting(
  documentRaw: any
): MerchantPackageRightPeakAccountApplicationDocumentSettingModel {
  return {
    cassification: documentRaw.cassification,
    redirectLinkReport: documentRaw.redirectLinkReport,
    taxInvoice: documentRaw.taxInvoice,
    journal: documentRaw.journal,
  };
}
function GetMerchantPackageRightPeakAccountApplicationUserSetting(
  userRaw: any
): MerchantPackageRightPeakAccountApplicationUserSettingModel {
  return {
    userRoleContact: userRaw.userRoleContact,
  };
}
function GetMerchantPackageRightPeakAccountApplicationAccountingPolicySetting(
  accountingPolicyRaw: any
): MerchantPackageRightPeakAccountApplicationAccountingPolicySettingModel {
  return {
    summaryReport: accountingPolicyRaw.summaryReport,
    creditLimit: accountingPolicyRaw.creditLimit,
    purchaseOrderStatusUpdate: accountingPolicyRaw.purchaseOrderStatusUpdate,
  };
}
function GetMerchantPackageRightPeakAccountApplicationSetting(
  settingRaw: any
): MerchantPackageRightPeakAccountApplicationSettingModel {
  return {
    user: GetMerchantPackageRightPeakAccountApplicationUserSetting(settingRaw.user),
    document: GetMerchantPackageRightPeakAccountApplicationDocumentSetting(settingRaw.document),
    accountingPolicy: GetMerchantPackageRightPeakAccountApplicationAccountingPolicySetting(settingRaw.accountingPolicy),
    applicationConnect: settingRaw.applicationConnect,
  };
}
function GetMerchantPackageRightPeakAccountApplication(
  accountRaw: any
): MerchantPackageRightPeakAccountApplicationModel {
  return {
    totalDocumentPerMonth: accountRaw.totalDocumentPerMonth,
    export: accountRaw.export,
    importProduct: accountRaw.importProduct,
    importContact: accountRaw.importContact,
    importTransaction: accountRaw.importTransaction,
    partailPayment: accountRaw.partailPayment,
    revenue: GetMerchantPackageRightPeakAccountApplicationRevenue(accountRaw.revenue),
    expense: GetMerchantPackageRightPeakAccountApplicationExpense(accountRaw.expense),
    finance: GetMerchantPackageRightPeakAccountApplicationFinance(accountRaw.finance),
    account: GetMerchantPackageRightPeakAccountApplicationAccounts(accountRaw.account),
    fileVault: accountRaw.fileVault,
    setting: GetMerchantPackageRightPeakAccountApplicationSetting(accountRaw.setting),
  };
}
function GetMerchantPackageRightPeakTaxApplication(taxRaw: any): MerchantPackageRightPeakTaxApplicationModel {
  return { fetchDataFromPeakAccount: taxRaw.fetchDataFromPeakAccount };
}
function GetMerchantPackageRightPeakAssetApplication(assetRaw: any): MerchantPackageRightPeakAssetApplicationModel {
  return { totalAsset: assetRaw.totalAsset };
}
function GetMerchantPackageRight(merchantPackageRightRaw: any): MerchantPackageRightModel {
  return {
    totalUserId: merchantPackageRightRaw?.totalUserId ?? 0,
    application: merchantPackageRightRaw
      ? GetMerchantPackageRightApplication(merchantPackageRightRaw.application)
      : new MerchantPackageRightApplicationModel(),
    account: merchantPackageRightRaw
      ? GetMerchantPackageRightPeakAccountApplication(merchantPackageRightRaw.account)
      : new MerchantPackageRightPeakAccountApplicationModel(),
    tax: merchantPackageRightRaw
      ? GetMerchantPackageRightPeakTaxApplication(merchantPackageRightRaw.tax)
      : new MerchantPackageRightPeakTaxApplicationModel(),
    asset: merchantPackageRightRaw
      ? GetMerchantPackageRightPeakAssetApplication(merchantPackageRightRaw.asset)
      : new MerchantPackageRightPeakAssetApplicationModel(),
  };
}
function GetRole(userRoleRaw: any): UserRoleInfoModel {
  return {
    authorityRole: userRoleRaw?.authorityRole ?? 0,
    role: userRoleRaw?.role ?? 0,
    manageUser: userRoleRaw?.manageUser ?? 0,
    manageFinance: userRoleRaw?.manageFinance ?? 0,
    isSuperUser: userRoleRaw?.isSuperUser ?? 0,
    isUsePayroll: userRoleRaw?.isUsePayroll ?? 0,
    isUsePeakBoard: userRoleRaw?.isUsePeakBoard ?? 0,
    manageProduct: userRoleRaw?.manageProduct ?? 0,
    isSeeSelfDocuments: userRoleRaw?.isSeeSelfDocuments ?? 0,
    manageFinanceAndJournals: userRoleRaw?.manageFinanceAndJournals ?? 0,
    manageAsset: userRoleRaw?.manageAsset ?? 0,
    manageContact: userRoleRaw?.manageContact ?? 0,
    isViewReport: userRoleRaw?.isViewReport ?? 0,
  };
}
export function GetSelectedMerchant(merchantRaw: any): SelectedMerchantModel {
  return {
    merchantId: merchantRaw.merchantId,
    merchantName: merchantRaw.merchantName,
    merchantNameEng: merchantRaw.merchantNameEng,
    merchantNameTh: merchantRaw.merchantNameTh,
    merchantBranchCode: merchantRaw.merchantBranchCode,
    merchantTaxId: merchantRaw.merchantTaxId,
    code: merchantRaw.code,
    createDateTime: merchantRaw.createDateTime,
    isAccountingFirm: merchantRaw.isAccountingFirm,
    merchantType: merchantRaw.merchantType,
    taxStatus: merchantRaw.taxStatus,
    logoUrl: merchantRaw.logoUrl,
    stampUrl: merchantRaw.stampUrl,
    isSample: merchantRaw.isSample,
    isVat: merchantRaw.isVat,
    isActivePayroll: merchantRaw.isActivePayroll,
    isLockPeriod: merchantRaw.isLockPeriod,
    lockPeriodEndDate: merchantRaw.lockPeriodEndDate,
    joinMerchantDateTime: merchantRaw.joinMerchantDateTime,
    package: merchantRaw.package,
    expireDateTime: merchantRaw.expireDateTime,
    packageName: merchantRaw.packageName,
    merchantPackageRight: GetMerchantPackageRight(merchantRaw.merchantPackageRight),
    role: GetRole(merchantRaw.role),
  };
}

export function IsOrdinaryPerson(contactType: MerchantType) {
  const isOrdinaryPerson =
    contactType === MerchantType.OrdinaryPerson ||
    contactType === MerchantType.Shop ||
    contactType === MerchantType.OrdinaryPartnership ||
    contactType === MerchantType.BodyOfPersons;
  return isOrdinaryPerson;
}

export function IsStartWithNumber(input: string) {
  const startNumberExp = /^\d/;
  return startNumberExp.test(input);
}

export function IsHaveThaiText(input: string) {
  /* eslint-disable no-misleading-character-class */
  const thRegExp = /[กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุูเแโใไๅๆ็่้๊๋์]/;
  return thRegExp.test(input);
}

export function GetMerchantAddress(addressDetail: any) {
  let address;

  if (!IsHaveThaiText(addressDetail.province)) {
    address =
      (addressDetail.address ? addressDetail.address + " " : "") +
      (addressDetail.building ? addressDetail.building + " " : "") +
      (addressDetail.floorNo ? addressDetail.floorNo + " " : "") +
      (addressDetail.roomNo ? addressDetail.roomNo + " " : "") +
      (addressDetail.homeGroup ? addressDetail.homeGroup + " " : "") +
      (addressDetail.homeNo ? addressDetail.homeNo + " " : "") +
      (addressDetail.soi ? addressDetail.soi + " " : "") +
      (addressDetail.road ? addressDetail.road : "");
  } else {
    address =
      (addressDetail.no ? "เลขที่ " + addressDetail.no + " " : "") +
      (addressDetail.building ? "อาคาร " + addressDetail.building + " " : "") +
      (addressDetail.floorNo ? "ชั้น " + addressDetail.floorNo + " " : "") +
      (addressDetail.roomNo ? "ห้องเลขที่ " + addressDetail.roomNo + " " : "") +
      (addressDetail.homeGroup ? "หมู่บ้าน " + addressDetail.homeGroup + " " : "") +
      (addressDetail.homeNo ? "หมู่ที่ " + addressDetail.homeNo + " " : "") +
      (addressDetail.soi ? "ซอย " + addressDetail.soi + " " : "") +
      (addressDetail.road ? "ถนน " + addressDetail.road : "");
  }
  if (!IsHaveThaiText(addressDetail.country) && !IsHaveThaiText(address)) {
    return `${address ? address : ""} ${addressDetail.subDistrict ? addressDetail.subDistrict : ""} ${
      addressDetail.district ? addressDetail.district : ""
    } ${addressDetail.province ? addressDetail.province : ""} ${addressDetail.country ? addressDetail.country : ""} ${
      addressDetail.postCode ? addressDetail.postCode : ""
    }`;
  } else {
    const districtPrefix = addressDetail.province
      ? addressDetail.province.startsWith("กรุงเทพ")
        ? "เขต"
        : "อำเภอ"
      : "";
    const subDistrictPrefix = addressDetail.province
      ? addressDetail.province.startsWith("กรุงเทพ")
        ? "แขวง"
        : "ตำบล"
      : "";
    const provincePrefix = addressDetail.province
      ? addressDetail.province.startsWith("กรุงเทพ")
        ? ""
        : "จังหวัด"
      : "";

    return `${address} ${subDistrictPrefix}${addressDetail.district1} ${districtPrefix}${addressDetail.district2} ${provincePrefix}${addressDetail.province} ${addressDetail.postCode}`;
  }
}

export function GetMerchantNameWihtOrdinaryPerson(
  name: string,
  namePrefixType: OrdinaryPersonPrefixType,
  namePrefixOther: string
) {
  let prefix = "";
  switch (namePrefixType) {
    case OrdinaryPersonPrefixType.Sir:
      prefix = i18n.t("PrefixName.Khun").toString();
      break;
    case OrdinaryPersonPrefixType.Mr:
      prefix = i18n.t("PrefixName.Mr").toString();
      break;
    case OrdinaryPersonPrefixType.Mrs:
      prefix = i18n.t("PrefixName.Mrs").toString();
      break;
    case OrdinaryPersonPrefixType.Ms:
      prefix = i18n.t("PrefixName.Ms").toString();
      break;
    case OrdinaryPersonPrefixType.Other:
      prefix = namePrefixOther;
      break;
  }

  return prefix + " " + name;
}

function GetMerchantName(merchantType: MerchantType) {
  let frontName = "";
  let backName = "";
  switch (merchantType) {
    case MerchantType.LimitedLiabilityPartnership:
      frontName = i18n.locale == "th" ? "ห้างหุ้นส่วนจำกัด " : "";
      backName = i18n.locale == "th" ? "" : " Limited Partnership";
      break;
    case MerchantType.CompanyLimited:
      frontName = i18n.locale == "th" ? "บริษัท " : "";
      backName = i18n.locale == "th" ? " จำกัด" : " Company Limited";
      break;
    case MerchantType.PublicCompanyLimited:
      frontName = i18n.locale == "th" ? "บริษัท " : "";
      backName = i18n.locale == "th" ? " จำกัด (มหาชน)" : " Public Company Limited";
      break;
    case MerchantType.Shop:
      frontName = i18n.locale == "th" ? "ร้าน " : "";
      backName = i18n.locale == "th" ? "" : " Shop";
      break;
    case MerchantType.OrdinaryPerson:
      frontName = "";
      backName = "";
      break;
    case MerchantType.BodyOfPersons:
      frontName = i18n.locale == "th" ? "คณะบุคคล " : "";
      backName = i18n.locale == "th" ? "" : " Body of Persons";
      break;
    case MerchantType.Others:
      frontName = "";
      backName = "";
      break;
    case MerchantType.OrdinaryPartnership:
      frontName = i18n.locale == "th" ? "ห้างหุ้นส่วนสามัญ " : "";
      backName = i18n.locale == "th" ? "" : " Ordinary Partnership";
      break;
    case MerchantType.Foundation:
      frontName = i18n.locale == "th" ? "มูลนิธิ " : "";
      backName = i18n.locale == "th" ? "" : " Foundation";
      break;
    case MerchantType.Association:
      frontName = i18n.locale == "th" ? "สมาคม " : "";
      backName = i18n.locale == "th" ? "" : " Association";
      break;
    case MerchantType.JointVenture:
      frontName = i18n.locale == "th" ? "กิจการร่วมค้า " : "";
      backName = i18n.locale == "th" ? "" : " Joint Venture";
      break;
  }
  return { frontName, backName };
}

export function GetMerchantNameWithMerchantType(merchantName: string, merchantType: MerchantType) {
  const nameType = GetMerchantName(merchantType);

  return nameType.frontName + merchantName + nameType.backName;
}

export function GetMerchantFullName(
  contactName: string,
  merchantType: MerchantType,
  namePrefixType = OrdinaryPersonPrefixType.None,
  namePrefixOther = ""
) {
  let contactFullName = "";
  switch (merchantType) {
    case MerchantType.OrdinaryPerson:
      contactFullName = GetMerchantNameWihtOrdinaryPerson(contactName, namePrefixType, namePrefixOther);
      break;

    default:
      contactFullName = GetMerchantNameWithMerchantType(contactName, merchantType);
      break;
  }

  return contactFullName;
}

export function GetMerchantBranchCode(branchCode: string) {
  const branchName =
    branchCode == "00000" ? ` (${i18n.t("head_quarter")})` : branchCode !== "" ? ` (${branchCode})` : "";
  return branchName;
}

export function GetMerchantTemplateDefault(taxId = "", branchCode = "") {
  const merchantTemplate: any = {
    taxId: {
      value: taxId,
      validateError: false,
    },
    branchTypeId: 1,
    branchCode: {
      value: branchCode,
      validateError: false,
    },
    typeOfPerson: { value: 2 }, //ประเภทบุคคล
    typeCompany: { value: MerchantType.CompanyLimited }, //นิติบุคคล
    otherTypeCompany: "", //???
    companyName: {
      //ชื่อกิจการ
      value: "",
      validateError: false,
    },
    prefixName: { value: PrefixNameType.Mr }, //คำหน้า
    prefixOtherName: {
      //คำหน้าอื่นๆ
      value: "",
      validateError: false,
    },
    firstname: {
      value: "",
      validateError: false,
    },
    lastname: {
      value: "",
      validateError: false,
    },
    merchantSizeEmployee: {
      value: 0,
    },
    merchantUsageType: {
      value: 0,
    },
    merchantTypeOfBusiness: {
      value: 0,
    },
    merchantVATRegistrationType: {
      value: 0,
    },
    registeredAddressType: 0,
    registeredAddress: {
      building: {
        value: "",
        validateError: false,
      },
      homeNo: {
        value: "",
        validateError: false,
      },
      village: {
        value: "",
        validateError: false,
      },
      villageNo: {
        value: "",
        validateError: false,
      },
      floor: {
        value: "",
        validateError: false,
      },
      roomNo: {
        value: "",
        validateError: false,
      },
      soi: {
        value: "",
        validateError: false,
      },
      road: {
        value: "",
        validateError: false,
      },
      district: {
        value: "",
        validateError: false,
      },
      amphoe: {
        value: "",
        validateError: false,
      },
      province: {
        value: "",
        validateError: false,
      },
      zipcode: {
        value: "",
        validateError: false,
      },
    },
    whoAreYou: 1,
    needCallBackToGuide: false,
    needSetupService: false,
    needToFindAccountingService: false,
    needToGetFinance: false,
  };

  return merchantTemplate;
}

function GetMerchantBranchCodeForCreateMerchant(merchantTemplate: any) {
  if (merchantTemplate.branchTypeId == BranchCompanyType.Quarter) {
    return "00000";
  } else {
    return merchantTemplate.branchCode.value ? merchantTemplate.branchCode.value : "00000";
  }
}

export function SetCreateMerchantModel(merchantTemplate: any) {
  const createMerchantModel = {
    merchantName:
      merchantTemplate.typeOfPerson.value == TypeOfPerson.OrdinaryPerson &&
      merchantTemplate.typeCompany.value == MerchantType.OrdinaryPerson
        ? merchantTemplate.firstname.value + " " + merchantTemplate.lastname.value
        : merchantTemplate.companyName.value,
    // no: GetAddressMerchant(merchantTemplate),
    no: merchantTemplate.registeredAddress.homeNo.value,
    building: merchantTemplate.registeredAddressType == 0 ? merchantTemplate.registeredAddress.building.value : "",
    roomNo: merchantTemplate.registeredAddressType == 0 ? merchantTemplate.registeredAddress.roomNo.value : "",
    floorNo: merchantTemplate.registeredAddressType == 0 ? merchantTemplate.registeredAddress.floor.value : "",
    homeGroup: merchantTemplate.registeredAddressType == 1 ? merchantTemplate.registeredAddress.village.value : "",
    homeNo: merchantTemplate.registeredAddress.villageNo.value,
    isVat: merchantTemplate.merchantVATRegistrationType.value == 0 ? false : true,
    soi: merchantTemplate.registeredAddress.soi.value,
    road: merchantTemplate.registeredAddress.road.value,
    district: merchantTemplate.registeredAddress.amphoe.value,
    subDistrict: merchantTemplate.registeredAddress.district.value,
    country: "Thailand",
    province: merchantTemplate.registeredAddress.province.value,
    postcode: merchantTemplate.registeredAddress.zipcode.value,
    taxId: merchantTemplate.taxId.value,
    branch: GetMerchantBranchCodeForCreateMerchant(merchantTemplate),
    merchantTypeId: merchantTemplate.typeCompany.value,
    accountingFirmId: null,
    businessCategoryId: merchantTemplate.merchantTypeOfBusiness.value,
    organizationSizeId: merchantTemplate.merchantSizeEmployee.value,
    createdUserPositionId: merchantTemplate.whoAreYou,
    userRequestSupportPhoneNumber: "",
    isRequestAccountingService: false,
    needCallBackToGuide: merchantTemplate.needCallBackToGuide,
    needSetupService: merchantTemplate.needSetupService,
    needToFindAccountingService: merchantTemplate.needToFindAccountingService,
    needToGetFinance: merchantTemplate.needToGetFinance,
  };

  return createMerchantModel;
}

export function SetMerchantCreateTemplateBySearchedMerchantAddress(merchantTemplate: any, searchedAddress: any) {
  merchantTemplate.taxId.value = searchedAddress.taxId;
  merchantTemplate.branchCode.value = searchedAddress.branchCode;
  merchantTemplate.typeOfPerson = GetTypeOfPersonBySearchedAddress(searchedAddress.merchantType);
  merchantTemplate.typeCompany = { value: searchedAddress.merchantType };
  if (
    merchantTemplate.typeOfPerson.value === TypeOfPerson.OrdinaryPerson &&
    searchedAddress.merchantType === MerchantType.OrdinaryPerson
  ) {
    const fullName = searchedAddress.name.split(/ (.*)/);
    merchantTemplate.firstname.value = fullName.length > 0 ? fullName[0] : "";
    merchantTemplate.lastname.value = fullName.length > 1 ? fullName[1] : "";
    merchantTemplate.prefixName = { value: searchedAddress.personalNamePrefixTypeId };
  } else {
    merchantTemplate.companyName.value = searchedAddress.name;
  }
  merchantTemplate.merchantVATRegistrationType = searchedAddress.isVat ? { value: 1 } : { value: 0 };

  merchantTemplate.registeredAddressType = searchedAddress.building ? 0 : 2;

  merchantTemplate.registeredAddress.building.value = searchedAddress.building;
  merchantTemplate.registeredAddress.homeNo.value = searchedAddress.no;
  merchantTemplate.registeredAddress.villageNo.value = searchedAddress.homeNo;
  merchantTemplate.registeredAddress.floor.value = searchedAddress.floorNo;
  merchantTemplate.registeredAddress.roomNo.value = searchedAddress.roomNo;
  merchantTemplate.registeredAddress.soi.value = searchedAddress.soi;
  merchantTemplate.registeredAddress.road.value = searchedAddress.road;

  merchantTemplate.registeredAddress.district.value = searchedAddress.subDistrict;
  merchantTemplate.registeredAddress.amphoe.value = searchedAddress.district;
  merchantTemplate.registeredAddress.province.value = searchedAddress.province;
  merchantTemplate.registeredAddress.zipcode.value = searchedAddress.postCode;

  return merchantTemplate;
}

export function GetVerifyMerchantTemplateDefault() {
  const verifyMerchantTemplate = {
    merchantFileImageModel: [],
    pp20FileImageModel: [],
    idCardImageModel: [],
    logoImageModel: [],
    taxId: {
      value: "",
      validateError: false,
    },
    firstName: {
      value: "",
      validateError: false,
    },
    lastName: {
      value: "",
      validateError: false,
    },
    phoneNo: {
      value: "",
      validateError: false,
    },
    email: {
      value: "",
      validateError: false,
    },
    consentVerification: false,
    membershipAgreement: false,
    isConfirm: false,
    isCheckCertificatePP20: false,
  };
  return verifyMerchantTemplate;
}

export function ConvertToVerificationMerchantRequestModel(verifyMerchantTemplate: any, merchantLogoList: Array<any>) {
  const verificationMerchantRequest = {
    merchantFileImageModel: [] as any,
    pp20FileImageModel: [] as any,
    idCardImageModel: [] as any,
    logoImageModel: [] as any,
    consentVerification: verifyMerchantTemplate.consentVerification,
    membershipAgreement: verifyMerchantTemplate.membershipAgreement,
  };

  if (verifyMerchantTemplate.merchantFileImageModel && verifyMerchantTemplate.merchantFileImageModel.length > 0) {
    verifyMerchantTemplate.merchantFileImageModel.forEach((item: any) => {
      verificationMerchantRequest.merchantFileImageModel.push({
        fileName: item.fileName,
        rawString: item.rawString,
        fileType: item.fileType,
        fileUrl: item.fileFullUrl,
      });
    });
  }

  if (verifyMerchantTemplate.isCheckCertificatePP20) {
    if (verifyMerchantTemplate.pp20FileImageModel && verifyMerchantTemplate.pp20FileImageModel.length > 0) {
      verifyMerchantTemplate.pp20FileImageModel.forEach((item: any) => {
        verificationMerchantRequest.pp20FileImageModel.push({
          fileName: item.fileName,
          rawString: item.rawString,
          fileType: item.fileType,
          fileUrl: item.fileFullUrl,
        });
      });
    }
  }

  if (verifyMerchantTemplate.idCardImageModel && verifyMerchantTemplate.idCardImageModel.length > 0) {
    verifyMerchantTemplate.idCardImageModel.forEach((item: any) => {
      verificationMerchantRequest.idCardImageModel.push({
        fileName: item.fileName,
        rawString: item.rawString,
        fileType: item.fileType,
        fileUrl: item.fileFullUrl,
      });
    });
  }

  if (merchantLogoList && merchantLogoList.length > 0) {
    merchantLogoList.forEach((item) => {
      verificationMerchantRequest.logoImageModel = {
        fileName: item.fileName,
        rawString: item.rawString,
        fileType: item.fileType,
        fileUrl: item.urlImg,
      };
    });
  }

  return verificationMerchantRequest;
}

export function ConvertToMerchantList(merchantListRaw: any): Array<MerchantInFoModel> {
  const merchantList: Array<MerchantInFoModel> = [];
  if (merchantListRaw && merchantListRaw.length > 0) {
    for (const merchantRaw of merchantListRaw) {
      merchantList.push({
        merchantId: merchantRaw.merchantId,
        merchantName: merchantRaw.merchantName,
        merchantNameEng: merchantRaw.merchantNameEng,
        merchantNameTh: merchantRaw.merchantNameTh,
        merchantBranchCode: merchantRaw.merchantBranchCode,
        isSample: merchantRaw.isSample,
        merchantTaxId: merchantRaw.merchantTaxId,
      });
    }
  }
  return merchantList;
}

export function CompareMerchantNameTh(a: MerchantInFoModel, b: MerchantInFoModel) {
  if (a.merchantNameTh < b.merchantNameTh) {
    return -1;
  } else if (a.merchantNameTh > b.merchantNameTh) {
    return 1;
  } else {
    return 0;
  }
}

export function CompareMerchantNameEn(a: MerchantInFoModel, b: MerchantInFoModel) {
  if (a.merchantNameEng < b.merchantNameEng) {
    return -1;
  } else if (a.merchantNameEng > b.merchantNameEng) {
    return 1;
  } else {
    return 0;
  }
}
